export const CATEGORY_COLORS = {
  Groceries: "#7CF7C2",
  Dining: "#FFD38A",
  Transport: "#7AD7FF",
  Travel: "#A7FFEA",
  Shopping: "#D7A7FF",
  Bills: "#22D3EE",
  Healthcare: "#FF9AA5",
  Entertainment: "#C792EA",
  Software: "#82AAFF",
  Other: "#B8C0CC",
};

export const CATEGORIES = Object.keys(CATEGORY_COLORS);

export function categoryColor(cat) {
  return CATEGORY_COLORS[cat] || CATEGORY_COLORS.Other;
}

export const CHART_COLORS = [
  "#22D3EE", "#7CF7C2", "#FFD38A", "#82AAFF", "#D7A7FF",
  "#7AD7FF", "#FF9AA5", "#A7FFEA", "#C792EA", "#B8C0CC",
];
